import React, { useRef, useState } from "react";
import "./Navbar.css";
import logo from "../../assets/logo.png";
import search_icon from "../../assets/search_icon.svg";
import bell_icon from "../../assets/bell_icon.svg";
import profile_img from "../../assets/profile_img.png";
import { NavLink } from "react-router-dom";
function Navbar({ setSearchMovie }) {
  const [showSearch,setShowSearch]=useState(false);
  const searchToggle=()=>{
    setShowSearch(!showSearch);
  }
  const searchInp = useRef();
  const setmovie = () => {
    setSearchMovie(searchInp.current.value);
    setShowSearch(false);
  };
  return (
    <nav className="navigation">
      <div className="container">
        <div className="d-flex justify-content-between align-items-cetner">
          <div className="rightNav">
            <div className="me-4">
              <img className="logo" src={logo} alt="Netflix logo" />
            </div>
            <ul className="navLink">
              <li>
                <a className="nav_a" href="#">
                  Home
                </a>
              </li>
              <li>
                <a className="nav_a" href="#">
                  Tv Shows
                </a>
              </li>
              <li>
                <a className="nav_a" href="#">
                  Movies
                </a>
              </li>
              <li>
                <a className="nav_a" href="#">
                  New & Popular
                </a>
              </li>
              <li>
                <a className="nav_a" href="#">
                  My List
                </a>
              </li>
              <li>
                <a className="nav_a" href="#">
                  Browse by Languages
                </a>
              </li>
            </ul>
          </div>
          <div className="leftNav">
            <div className="leftNav_link">
              <img
                className="search_icon"
                src={search_icon}
                onClick={searchToggle}
                alt="Search_icon"
              />
              <span className="navSpan">Children</span>
              <img src={bell_icon} alt="bell icon" />
              <div className="login_profle_div">
                <img src={profile_img} alt="Profile" className="profile_img" />
                <span className="dropdown">
                  <i className="fa-solid fa-chevron-down"></i>
                </span>
                <div className="logout">
                  <NavLink to="/login" className="logout-btn">
                    Logout
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
        {showSearch && <div className="search-Wrapper">
          <div className="seachbar">
            <input type="text" placeholder="Search here. . . " ref={searchInp} />
            <img
              className="search_icon"
              src={search_icon}
              onClick={setmovie}
              alt="Search_icon"
            />
          </div>
        </div>
        }
      </div>
    </nav>
  );
}

export default Navbar;
